interface CampaignStatusLike {
  status?: string | null;
  campaign_type?: string | null;
  end_date?: string | null;
}

/** Respect CPM deadlines while a persisted status or an open tab catches up. */
export function getCpmCampaignStatus(
  campaign: CampaignStatusLike | null | undefined,
  now: Date,
): string | null | undefined {
  if (campaign?.status === 'active' && campaign.campaign_type !== 'ranking'
    && campaign.end_date && Date.parse(campaign.end_date) <= now.getTime()) {
    return 'ended';
  }
  return campaign?.status;
}
